import { render, staticRenderFns } from "./OrganizationPage.vue?vue&type=template&id=579d7277&"
import script from "./OrganizationPage.vue?vue&type=script&lang=js&"
export * from "./OrganizationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports